import { InjectionBatchForm } from "@/components/tools/flash-injection/InjectionBatchForm";
import { InjectionBatchList } from "@/components/tools/flash-injection/InjectionBatchList";
import { ManualInjectionBatchForm } from "@/components/tools/flash-injection/ManualInjectionBatchForm";
import { DiabolocomInjectionPage } from "@/pages/tools/flash-injection";
import { DataService } from "@/services/data";
import { UserType } from "@/types/user";
import { handle_error, handle_success } from "@/utils/wretch";
import { RouteObject } from "react-router-dom";

export const DiabolocomInjectionRoute: RouteObject = {
    path: "injection-flash",
    element: <DiabolocomInjectionPage />,
    children: [
        {
            path: "",
            element: <InjectionBatchList />,
            loader: async ({ request }) => {
                const url = new URL(request.url);
                if (!url.searchParams.has("page_size")) {
                    url.searchParams.set("page_size", "25");
                }
                return DataService.client
                    .url(`/tools/flash-injection/${url.searchParams ? "?" + url.searchParams.toString() : ""}`)
                    .get()
                    .json();
            }
        },
        {
            path: "new",
            element: <InjectionBatchForm />,
            action: async ({ request }) => {
                const data = await request.json();

                try {
                    return handle_success(await DataService.client.url("/tools/flash-injection/").post(data).json());
                } catch (error) {
                    return handle_error(error);
                }
            }
        },
        {
            path: "new_manual",
            element: <ManualInjectionBatchForm />,
            action: async ({ request }) => {
                const data = await request.json();

                try {
                    return handle_success(await DataService.client.url("/tools/flash-injection/manual/").post(data).json());
                } catch (error) {
                    return handle_error(error);
                }
            }
        },
        {
            path: "picklists/agents",
            loader: async () => {
                return (await DataService.client.get("/tools/flash-injection/agents/").json()) as {
                    users: UserType[];
                };
            }
        },
        {
            path: "cases",
            action: async ({ request }) => {
                const data = await request.json();

                try {
                    return handle_success(await DataService.client.url("/tools/flash-injection/cases/").post(data).json());
                } catch (error) {
                    return handle_error(error);
                }
            }
        },
        {
            path: "reset_flash",
            action: async ({ request }) => {
                const data = await request.json().catch(() => ({}));
                try {
                    return handle_success(await DataService.client.url("/tools/flash-injection/reset_flash/").post(data).json());
                } catch (error) {
                    return handle_error(error);
                }
            }
        }
    ]
};
